<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="cip">
<p class="cipf">Copyright © 2011 by Ralph Peters</p>
<p class="cipf">Published by</p>
<p class="cip">STACKPOLE BOOKS</p>
<p class="cip">5067 Ritter Road</p>
<p class="cip">Mechanicsburg, PA 17055</p>
<p class="cip"><a href="http://www.stackpolebooks.com" target="_blank">www.stackpolebooks.com</a></p>
<p class="cipf">All rights reserved, including the right to reproduce this book or portions thereof in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher. All inquiries should be addressed to Stackpole Books, 5067 Ritter Road, Mechanicsburg, Pennsylvania 17055.</p>
<p class="cipf">Printed in the United States of America</p>
<p class="cipf">10 9 8 7 6 5 4 3 2 1</p>
<p class="cipf">First edition</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Peters, Ralph, 1952-</p>
<p class="cip">Lines of fire : a renegade writes on strategy, intelligence, and security / Ralph Peters.</p>
<p class="cip1">p. cm.</p>
<p class="cip">ISBN-13: 978-0-8117-0588-2 (hbk.)</p>
<p class="cip">ISBN-10: 0-8117-0588-9 (hbk.)</p>
<p class="cip">1. United States—Military policy. 2. National security—United States. 3. Military art and science. 4. Strategy. 5. World politics—21st century. I. Title. </p>
<p class="cip">UA23.P694 2011</p>
<p class="cip">355'.033573—dc23</p>
<p class="cip2">2011016188</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spblinesoffire0004.vue?7d097240